<template>
  <div class="dashboard-container">
    <h1>数据概况</h1>
    <el-row :gutter="20">
      <el-col :span="8" v-for="(item, index) in overView" :key="index">
        <el-card class="grid-content bg-purple" shadow="always">
          <h2>{{ item.title }}</h2>
          <ul>
            <li>
              <span>今日</span>
              <p>{{ item.today }}</p>
              <span>较前1日 {{ item.today_growth }}%</span>
            </li>
            <li>
              <span>本周</span>
              <p>{{ item.week }}</p>
              <span>较上周 {{ item.week_growth }}%</span>
            </li>
            <li>
              <span>本月</span>
              <p>{{ item.month }}</p>
              <span>较上月 {{ item.month_growth }}%</span>
            </li>
          </ul>
        </el-card>
      </el-col>
    </el-row>
    <el-card shadow="always">
      <ProjectData ref="projectData" />
    </el-card>
    <el-card shadow="always" style="margin-top: 20px">
      <SourceData ref="projectData" />
    </el-card>
  </div>
</template>

<script>
import { getDataOverview } from '@/api/dashboard'
export default {
  name: 'Dashboard',
  components: {
    ProjectData: () => import('./components/ProjectData'),
    SourceData: () => import('./components/SourceData')
  },
  data() {
    return {
      overView: [],
      projectData: []
    }
  },
  created() {
    getDataOverview().then((res) => {
      const { price, order_num, user_num } = res.data
      this.overView = [
        { title: '营业额', ...price },
        { title: '订单数', ...order_num },
        { title: '出行人数', ...user_num }
      ]
    })
  },
  methods: {}
}
</script>
<style lang="less">
.dashboard-container {
  padding: 20px;
  h1 {
    font-size: 20px;
  }
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  h2 {
    font-size: 16px;
    color: #666;
    margin: 0;
    margin-bottom: 10px;
  }
  ul,
  li {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  li {
    display: flex;
    line-height: 30px;
    align-items: center;
    justify-content: space-between;
    span {
      display: block;
      color: #999;
      font-size: 12px;
    }
    p {
      font-size: 22px;
      font-weight: bold;
      margin-right: auto;
      margin-left: 10px;
      color: rgba(113, 138, 235, 1);
    }
  }
}

.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
